import {Injectable, NgModule} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterModule, RouterStateSnapshot, Routes} from '@angular/router';
import {LiveViewerComponent} from './live-viewer/live-viewer.component';
import {ProductListComponent} from './product-list/product-list.component';
import {LiveSellerComponent} from './live-seller/live-seller.component';
import {LiveDashboardComponent} from './live-seller/live-dashboard/live-dashboard.component';
import { Observable, of } from 'rxjs';
import { ProductSearchService } from './service/product-search.service';
import { CategorySearchService } from './service/category-search.service';
import {TestLinkComponent} from './test-link/test-link.component';
import {LiveListRoomComponent} from './live-list-room/live-list-room.component';

@Injectable({providedIn: 'root'})
export class ProjectIdResolve implements Resolve<string> {
  constructor(private service: ProductSearchService, private categoryService: CategorySearchService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<string> {
    const pid = route.paramMap.get('id') ? route.paramMap.get('id') : null;
    this.service.projectId = pid;
    this.service.loadSearchUrl();
    this.categoryService.projectId=pid;
    this.categoryService.loadSearchUrl();
    return of(pid);
  }
}

const routes: Routes = [
    {path: 'rooms/:projectId-roomId', component: LiveViewerComponent},
    {path: 'products', component: ProductListComponent},
    {
        path: 'project',
        component: LiveSellerComponent,
        children: [
            {
                path: ':id/streamer',
                component: LiveDashboardComponent,
                resolve: {
                    projectId: ProjectIdResolve
                }
            }
        ]
    },
    {path: 'test-page', component: TestLinkComponent},
    {path: 'p/:projectId/rooms', component: LiveListRoomComponent}

];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
